import { Attr, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ViewedItem from "./ViewedItem";

@Model()
class FeatureTeaser extends ApplicationRecord {
  static jsonapiType = "feature_teasers";

  @Attr({ persist: false }) createdAt: string;

  @Attr() featureId: number;

  @Attr() featureName: string;

  @Attr({ persist: false }) updatedAt: string;

  @HasMany({ name: "target" }) viewedItems: ViewedItem[];
}

export default FeatureTeaser;
